var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "none",
    stroke: "#17a34a",
    strokeWidth: 66.666664,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 533.333313 100 C 533.333313 81.590698 518.410034 66.666687 500 66.666687 L 300 66.666687 C 281.590637 66.666687 266.666656 81.590698 266.666656 100 L 266.666656 266.666687 L 100 266.666687 C 81.590668 266.666687 66.666664 281.590332 66.666664 300 L 66.666664 500 C 66.666664 518.410034 81.590668 533.333374 100 533.333374 L 266.666656 533.333374 L 266.666656 700 C 266.666656 718.409973 281.590637 733.333313 300 733.333313 L 500 733.333313 C 518.410034 733.333313 533.333313 718.409973 533.333313 700 L 533.333313 533.333374 L 700 533.333374 C 718.409973 533.333374 733.333313 518.410034 733.333313 500 L 733.333313 300 C 733.333313 281.590637 718.409973 266.666687 700 266.666687 L 533.333313 266.666687 L 533.333313 100 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.c6d01a720cf4b9cb93ce0f3634e556e2.svg";
export { ForwardRef as ReactComponent };